import React from "react";
import { Download, RotateCcw, Ban, CheckCircle2, XCircle } from "lucide-react";
import { Badge, btn, labelCls, fmtBytes, fmtDate, fmtDateTime, docsLabel } from "@/components/accounting/ui";

const linkState = (x) => {
  if (x.status !== "gesendet") return null;
  if (x.revoked_at) return "Link widerrufen";
  if (!x.active) return "Link abgelaufen";
  return `Link gültig bis ${fmtDate(x.expires_at)}`;
};

export const DispatchLog = ({ dispatches, exportsById, onResend, onRevoke }) => (
  <div data-testid="acc-dispatch-log">
    <p className={labelCls}>Versandprotokoll</p>
    {dispatches.length === 0 && <p className="text-xs text-faint mt-3">Für diesen Monat wurde noch nichts versendet.</p>}
    <div className="mt-3 space-y-2">
      {dispatches.map((x) => {
        const ex = exportsById[x.export_id];
        const ok = x.status === "gesendet";
        return (
          <div key={x.id} className="rounded-lg border border-line px-4 py-3 flex gap-3" data-testid={`acc-dispatch-${x.id}`}>
            {ok ? <CheckCircle2 size={16} className="text-emerald-600 shrink-0 mt-0.5" /> : <XCircle size={16} className="text-red-600 shrink-0 mt-0.5" />}
            <div className="flex-1 min-w-0">
              <p className="text-sm text-ink"><span className="font-semibold">{ok ? "Gesendet" : "Fehlgeschlagen"}</span> · {fmtDateTime(x.created_at)}</p>
              <p className="text-xs text-dim mt-0.5 break-all">{x.filename}</p>
              <p className="text-[11px] text-faint mt-0.5 break-all">An: {x.to.join(", ")} · von {x.created_by}</p>
              {ok && <p className="text-[11px] text-faint mt-0.5">{linkState(x)} · {x.downloads} {x.downloads === 1 ? "Download" : "Downloads"}</p>}
              {!ok && <p className="text-[11px] text-red-600 mt-0.5 break-words" data-testid={`acc-dispatch-error-${x.id}`}>{x.error}</p>}
              <div className="flex gap-1.5 mt-2.5 empty:hidden">
                {x.active && <button type="button" onClick={() => onRevoke(x)} className={btn} data-testid={`acc-dispatch-revoke-${x.id}`}><Ban size={12} /> Link widerrufen</button>}
                {!x.active && ex && ex.status !== "ersetzt" && (
                  <button type="button" onClick={() => onResend(ex)} className={btn} data-testid={`acc-dispatch-resend-${x.id}`}><RotateCcw size={12} /> Erneut senden</button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export const ArchiveList = ({ exports, onDownload }) => (
  <div data-testid="acc-archive-list">
    <p className={labelCls}>Übermittelte Archive</p>
    {exports.length === 0 && <p className="text-xs text-faint mt-3">Noch keine übermittelten Archive für diesen Monat.</p>}
    <div className="mt-3 space-y-2">
      {exports.map((e) => (
        <div key={e.id} className="rounded-lg border border-line px-4 py-3 flex items-center gap-3" data-testid={`acc-archive-${e.id}`}>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-ink font-medium truncate">{e.filename}</p>
            <p className="text-[11px] text-faint mt-0.5">{docsLabel(e.doc_count)} · {fmtBytes(e.zip_size || e.total_size)} · übermittelt {fmtDateTime(e.sent_at)}</p>
          </div>
          {e.kind === "nachlieferung" && <Badge tone="amber">Nachlieferung</Badge>}
          <button type="button" onClick={() => onDownload(e)} className={btn} data-testid={`acc-archive-download-${e.id}`}><Download size={12} /> ZIP</button>
        </div>
      ))}
    </div>
  </div>
);
